// @ts-nocheck
/* eslint-enable */
// Action creators
import {
  FilterActions_fetchFilterFromUrlAndApi,
  FilterActions_fetchPriceHistogramFilterData,
} from 'app/shared/flux/actions/FilterActions';
import AreaActions from 'app/shared/flux/actions/AreaActions';
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';
import { batch } from 'react-redux';

// Utils
import gmapUtils from 'app/client/utils/map/gmapUtils';
import CONSTANTS from 'app/shared/constants/ValueConstants';
import AppActions from 'app/shared/flux/actions/AppActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';

export const csrFetchFilterFromUrlAndApi = (pathname, query) => {
  return (dispatch) => {
    return dispatch(FilterActions_fetchFilterFromUrlAndApi(pathname, query)).then((res) => {
      if (res.error) {
        return {
          changeHttpStatus: 404,
        };
      }

      return res;
    });
  };
};

export const csrFetchListingsOnly = (query) => {
  return (dispatch, getState) => {
    const currState = getState();
    const page = query.page ? Math.max(query.page, 0) : 0;
    const gmapLoaded = currState.app.gmapLoaded;
    const shouldUseAreaBoundary = query.border !== false;
    const mapData = gmapLoaded ? gmapUtils.getMapData(window.map) : null;

    const byCoordsParams = {
      filter: currState.filter,
      page,
      mapData,
      shouldUseAreaBoundary,
    };

    return dispatch(ListingEngineActions.fetchListingsOnlyByCoords(byCoordsParams));
  };
};

export const csrFetchListingsAndHistogramData = (query) => {
  return (dispatch, getState) => {
    const currState = getState();
    const gmapLoaded = currState.app.gmapLoaded;
    const shouldUseAreaBoundary = query.border !== false;
    const mapData = gmapLoaded ? gmapUtils.getMapData(window.map) : null;

    const priceHistogramFiParams = {
      mapData,
      shouldUseAreaBoundary,
    };

    batch(() => {
      // Fetch listings
      dispatch(csrFetchListingsOnly(query));

      // Fetch new price histogram filter data
      dispatch(FilterActions_fetchPriceHistogramFilterData(priceHistogramFiParams));
    });
  };
};

export const csrFetchAreaDataByResourceId = (resourceId, type = 'RESOURCE_ID') => {
  return (dispatch) => {
    // What two things can change on an SRP? Query & Resource id
    if (type === 'RESOURCE_ID') {
      return dispatch(AreaActions.fetchAreaDataByResourceId(resourceId));
    }
  };
};

export const csrFetchListingsAndOtherData = (pathname, query) => {
  return (dispatch, getState) => {
    const currState = getState();
    const page = query.page ? Math.max(query.page, 0) : 0;
    const promises = [];
    const byCoordsAndHistogramParams = {
      filter: currState.filter,
      page,
    };
    const seoFooterLinksParams = {
      resourceId: currState.area.area.resourceId,
      searchSlug: currState.filter.search.slug,
    };

    // Promises will be called in parallel i.e. none of these calls depend on each other
    promises.push(
      dispatch(ListingEngineActions.fetchListingsOnlyByCoords(byCoordsAndHistogramParams)),
      dispatch(AreaActions.fetchPriceHistogramData(byCoordsAndHistogramParams)),
      dispatch(AreaActions.loadAreaSeoLinks(seoFooterLinksParams)),
    );

    return Promise.all(promises);
  };
};

export const csrCheckAndFetchNearbyListings = () => {
  return (dispatch, getState) => {
    const latestState = getState();
    const maxBuildings = latestState.listings.totalBuildings;
    const maxPage = Math.max(Math.ceil(maxBuildings / CONSTANTS.MAX_LISTINGS_PER_PAGE), 1);
    const currentPage = latestState.location.current && latestState.location.current.query.page;
    const onLastPage = maxPage === Number(currentPage) || (maxPage === 1 && !currentPage);

    if (onLastPage) {
      const areaResourceId = latestState.area.area.resourceId;
      return dispatch(ListingEngineActions.fetchNearbyAreasListingsForMobileSRP(areaResourceId));
    }

    return Promise.resolve({ success: true });
  };
};

export const csrFetchGeoLocation = () => {
  return (dispatch, getState) => {
    const latestState = getState();
    const ip = latestState.app.ip;

    return dispatch(AppActions.getGeoIp({ ip }))
      .then((res) => res)
      .catch((err) => dispatch(ErrorActions.errorHandler({ err, location: 'SearchResultsPage#csrLoadGeolocation' })));
  };
};
